import President from "../assets/president.jpg";
import Image1 from "../assets/TeamImage1.jpeg";

import Image3 from "../assets/TeamImage3.jpeg";
import Image4 from "../assets/TeamImage4.jpg";
import Image5 from "../assets/TeamImage5.jpeg";
import Image6 from "../assets/TeamImage6.jpeg";
import Image7 from '../assets/TeamImage7.jpg'
import Image11 from "../assets/TeamImage11.jpg";
import Image12 from "../assets/TeamImage12.jpeg";
import Image21 from "../assets/TeamImage21.jpeg";
// import Image23 from "../assets/TeamImage23.jpeg";
import Image24 from "../assets/TeamImage24.jpeg";
import Image25 from "../assets/TeamImage25.jpeg";
import Image27 from "../assets/TeamImage27.jpeg";

const TeamData = [
  {
    name: "Mr. Naresh Rijal",
    position: "President",
    image: President,
  },
  {
    name: "Mr. Dipesh Rijal",
    position: "Vice-President",
    image: Image1,
  },
  {
    name: "Ms. Pragya Kandel",
    position: "Executive Vice-President",
    image: Image27,
  },
  {
    name: "Ms. Sujina Bhatta",
    position: "General Secretary",
    image: Image3,
  },
  // {
  //   name: "Mr. Dorchi Ngomba",
  //   position: "Secretary",
  //   image: Image23,
  // },
  {
    name: "Mr.Sanu kaji Thapa",
    position: "Advisor",
    image: Image5,
  },
  {
    name: "Mr. Ram Prasad Marasini",
    position: "Policy Advisor",
    image: Image25,
  },
  {
    name: "Mr Tanka Prasad Poudel",
    position: "Senior Researcher",
    image: Image24,
  },
  {
    name: "Mr. Temba Sherpa ",
    position: "Digital Researcher",
    image: Image21,
  },

  {
    name: "Ms. Phu Dhoma Gurung",
    position: "Environment and Health Researcher",
    image: Image11,
  },
  {
    name: "Mr. Pierre René Heymann",
    position: "International  committee and Life time Health Advisor",
    image: Image12,
  },
  // {
  //   name: "Mr. Lalit Roka ",
  //   position: "Central Committee Member",
  //   image: Image26,
  // },
  {
    name: "Hon'ble Hira Gurung",
    position: "Member",
    image: Image6,
  },
  {
    name: "Mr. Aakash Shrestha",
    position: "Member",
    image: Image4,
  },
  {
    name: "Mr. Roshan Dalami",
    position: "Member",
    image: Image7

  },
];

export default TeamData;
